export enum WorkOrderAccountingRuleCalculationType {
  None = 0,
  FlatRate = 1,
  Component = 2
}
